export enum NeuroTranslationStates {
  NOT_TRANSLATED = 'not_translated_with_neurotolge',
  TRANSLATED = 'translated_with_neurotolge'
}

export const neuroTranslationAlertId = 'neuro-translation';